"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sentryDefaultBeforeSend = exports.SENTRY_DEFAULT_CLIENT_IGNORE_ERRORS = exports.SENTRY_DEFAULT_CLIENT_DENY_URLS = void 0;
/**
 * Reusable client ignore errors for browser facing apps
 */
const SENTRY_DEFAULT_CLIENT_IGNORE_ERRORS = [
// Ignore [object Object] which don't have a stack trace and are very hard to debug
// https://github.com/getsentry/raven-js/pull/1181
/^\[object Object]$/,
// Ignore any errors related to cookies not being enabled.
/Cookies are not enabled/,
// Ignore IE related error regarding sessionStorage not being available (CED-6453)
/sessionStorage is not available/,
// Ignore IE related error regarding IndexedDb initialization failure (CED-6627)
/IndexedDb initialization failed/,
// Ignore resizeObserver error as it indicates that observations were sent over multiple animation frames
// instead of just one. See https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
// Non-WebKit Chrome Browser: "ResizeObserver loop limit exceeded"
// All other browsers: "ResizeObserver loop completed with undelivered notifications."
// (CED-10974)
/ResizeObserver loop limit exceeded/, /ResizeObserver loop completed with undelivered notifications/,
// Ignore error from known/bad Chrome Extension (CED-9952)
/ceCurrentVideo\.currentTime/,
// Ignore error from Mozilla extensions (CED-11173)
/csRestoreTitle is not defined/,
// Ignore error from Mobile Safari "Smart Invert Mode" (CED-9950)
/document\.head\.querySelector\("meta\[name='supported-color-schemes']"\)\.content/,
//Ignore error from Evernote extension (CED-11094)
/There is no clipping info for given tab/,
// Ignore timeout error from bug in third party libraries (CED-9399)
/Non-Error promise rejection captured with value: Timeout/,
// Random plugins/extensions
/vid_mate_check is not defined/, /SymBrowser_ModifyAnchorTagWithTarget/, /removeNightMode is not defined/,
// Ignore alerts fromm low-level code (CED-32772, PAT-393)
/undefined is not an object \(evaluating 'window\.webkit\.messageHandlers/,
// Ignore alerts only showing in mobile safari for react button clicks (CED-32875)
/The index is not in the allowed range/,
// Don't send these errors to sentry as these errors come when a user on Safari or Mobile Safari tries to cancel
// the page load while fetching, and this error doesn't hinder the UI experience
// Slack thread with more information
// https://cedar-slack.slack.com/archives/CRMPWTD42/p1666241268341159?thread_ts=1666197573.316689&cid=CRMPWTD42
// Stackoverflow post with more information
// https://stackoverflow.com/questions/55738408/javascript-typeerror-cancelled-error-when-calling-fetch-on-ios/60860369#60860369
/TypeError: Failed to fetch/, /TypeError: NetworkError when attempting to fetch resource./, /TypeError: cancelled/, /TypeError: Load failed/,
// PROD-16798
// AbortError is thrown when the browser cancels a fetch (e.g. user navigates away).
// Not user-impacting;
/AbortError: The user aborted a request/,
// PROD-10265
// Ignore these alerts that come from chromium bots
/UnhandledRejection: Non-Error promise rejection captured with value: Object Not Found Matching Id:/,
// PROD-13158
// Firefox/Safari Reader Mode injected scripts
/window\.__firefox__/, /__firefox__/,
// Crypto wallet browser extensions (MetaMask, Coinbase Wallet, etc.)
/window\.ethereum/,
// AxiosErrors are not actionable
/AxiosError/,
// Kora Chat - caused by Sierra SDK. Benign, only indicates proper de-duplication of resume events.
/Client event "resume-session" send already in progress/,
// jQuery is being injected by iOS in-app browsers (e.g. Apple Mail), but fails because Cedar does not load jQuery.
// This failure has no user-facing impact.
/Can't find variable: \$/,
// Third party libraries mutated the dom. Causes react hydration cycle to go out of sync.
// Not much we can do
/The object can not be found here/i, /The node to be removed is not a child of this node/i,
// Press Ganey's own CDN script throws this when a program fails to load. Unactionable from Cedar.
// PROD-17369 / Sentry CEDAR-2C6B
/Cannot load program: https:\/\/cdn\.hxplatform\.pressganey\.com/,
// Safari Web Extension content scripts throw this when messaging their background process
// fails (variants include "Tab not found." and "An unknown error occurred."). Arrives as an
// unhandled rejection with no stack frames, so denyUrls (webkit-masked-url) can't catch it.
// runtime.sendMessage is a WebExtension-only API, so any variant is unactionable from Cedar.
// (Sentry CEDAR-23Y9)
/Invalid call to runtime\.sendMessage\(\)/];

/**
 * Reusable denyUrls for browser facing apps.
 * These filter errors by stack frame URL, complementing ignoreErrors which only matches error messages.
 */
exports.SENTRY_DEFAULT_CLIENT_IGNORE_ERRORS = SENTRY_DEFAULT_CLIENT_IGNORE_ERRORS;
const SENTRY_DEFAULT_CLIENT_DENY_URLS = [
// Ignore errors originating from Safari browser extension scripts.
// https://bugs.webkit.org/show_bug.cgi?id=246010
/webkit-masked-url/,
// Safari masks extension script URLs as "//hidden/" in stack frames — also unactionable
/\/\/hidden\//,
// Ignore third party extensions
/extensions\//i, /^chrome-extension:\/\//i, /^moz-extension:\/\//i];

/**
 * Handler to filter out exceptions that are unactionable
 * and requires additional logic / exception object.
 * Choose ignoreErrors when you want a low-overhead config to discard common,
 * low-value exceptions that match specific text patterns
 * @param event
 * @param hint
 * @returns
 */
exports.SENTRY_DEFAULT_CLIENT_DENY_URLS = SENTRY_DEFAULT_CLIENT_DENY_URLS;
const sentryDefaultBeforeSend = (event, hint) => {
  if (hint?.originalException?.name === "AbortError") return null;
  return event;
};
exports.sentryDefaultBeforeSend = sentryDefaultBeforeSend;